<template>
  <div>
    <gg-input-label>{{ label }}</gg-input-label>
    <div class="d-flex">
      <label v-if="searchPrefix" class="pt-2 pr-2">{{ searchPrefix }}</label>
      <v-combobox
        v-model="searchVal"
        outlined
        dense
        hide-details
        class="gg-input"
        :loading="loading"
        :items="items"
        :name="name"
        no-filter
        :error-messages="errorMessages"
        :search-input.sync="searchVal"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import debounce from 'lodash.debounce'

export default {
  name: 'AutocompleteDir',
  model: {
    event: 'input',
    prop: 'directory'
  },
  $_veeValidate: {
    // value getter
    value () {
      return this.search
    },
    // name getter
    name () {
      return this.name
    }
  },
  props: {
    name: String,
    directory: String,
    errorMessages: Array,
    label: {
      type: String,
      default: 'Directory',
    },
    withPrefix: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      items: [],
      search: null
    }
  },
  computed: {
    searchPrefix () {
      if (!this.search || !this.withPrefix) {
        return ''
      }
      const parts = this.search.split('/')
      const dir = parts[1] || ''
      const user = parts[2] || ''
      return `/${dir}/${user}/`
    },
    searchVal: {
      get () {
        if (!this.search) {
          return ''
        }
        if (!this.withPrefix) {
          return this.search
        }
        return this.search.replace(this.searchPrefix, '')
      },
      set (val) {
        const prefix = this.searchPrefix || ''
        const value = val || ''
        this.search = prefix + value
        this.$emit('input', this.search)
      }
    }
  },
  methods: {
    ...mapActions({
      autocompleteDir: 'ftp/autocompleteDir',
      reportError: 'reportError',
    }),
    autocomplete: debounce(async function (path) {
      this.loading = true
      try {
        const response = await this.autocompleteDir({ path, list_all: '1' })
        const newItems = response.data.reduce((carry, { file }) => {
          carry.push(file)
          return carry
        }, [])
        this.items.splice(0, this.items.length, ...newItems)
        this.loading = false
      } catch (e) {
        this.loading = false
        this.items = []
        this.reportError(e)
      }
    }, 700)
  },
  watch: {
    search (val) {
      val && this.autocomplete(val)
    },
    directory (val) {
      this.search = val
    }
  }
}
</script>
